// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2WJnK","overflowing":"ReadFullNote_overflowing__1BE1a"};